import React from "react";
import { Modal, Button, Table } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import { dateFormatFull } from 'utils/FormatDate'

const Detail = ({
    show,
    handleClose,
    data,
    handleAction,
}) => {
    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size="md">
            <Modal.Header className="bg-card-gradient light border-bottom-0">
                <Modal.Title className="text-white">Detail Data</Modal.Title>
            <FalconCloseButton onClick={handleClose} variant="white" />
            </Modal.Header>
                <Modal.Body>
                    <Table bordered>
                        <tbody>
                            <tr>
                                <td width="40%">Kode Reservasi</td>
                                <td>{data ? data.vccode : ''}</td>
                            </tr>
                            <tr>
                                <td>Nama Pemesan</td>
                                <td>{data ? data.vcname : ''}</td>
                            </tr>
                            <tr>
                                <td>Alamat</td>
                                <td>{data ? data.vcaddress : ''}</td>   
                            </tr>
                            <tr>    
                                <td>No HP / WA</td>
                                <td>{data ? data.vcphone : ''}</td>
                            </tr>
                            <tr>    
                                <td>Keperluan</td>
                                <td>{data ? data.vcnecessary : ''}</td>
                            </tr>
                            <tr>    
                                <td>Tanggal Pemakaian</td>
                                <td>{data ? dateFormatFull(data.vcdate) : ''}</td>
                            </tr>
                            <tr>    
                                <td>Durasi</td>
                                <td>{data ? data.intduration : ''} Hari</td>
                            </tr>
                            <tr>    
                                <td>Total Unit</td>
                                <td>{data ? data.inttotal_unit : ''}</td>
                            </tr>
                            <tr>    
                                <td>Status</td>
                                <td>{data ? data.intstatus : ''}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Modal.Body>
            <Modal.Footer>
                <Button variant="success" onClick={() => handleAction('approve', data.intid)}>
                    <FontAwesomeIcon icon={faTimes} className="me-2" /> Setujiui
                </Button>
                <Button variant="danger" onClick={() => handleAction('reject', data.intid)}>
                    <FontAwesomeIcon icon={faTimes} className="me-2" /> Tolak
                </Button>
                <Button variant="secondary" onClick={handleClose}>
                    <FontAwesomeIcon icon={faTimes} className="me-2" /> Tutup
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

Detail.propTypes = {}

export default Detail;